/* Client-side wishlist (PRD §2.3): localStorage-backed heart toggles.
   Guest-friendly, per-browser persistence. Customer-metafield sync via the
   Storefront API is a flagged stretch goal, deliberately not implemented. */
if (!customElements.get('wishlist-button')) {
  customElements.define(
    'wishlist-button',
    class WishlistButton extends HTMLElement {
      static get storageKey() {
        return 'squl:wishlist';
      }

      static read() {
        try {
          const parsed = JSON.parse(localStorage.getItem(WishlistButton.storageKey));
          return Array.isArray(parsed) ? parsed : [];
        } catch (error) {
          return [];
        }
      }

      static write(handles) {
        try {
          localStorage.setItem(WishlistButton.storageKey, JSON.stringify(handles));
        } catch (error) {
          // Storage unavailable (private mode/quota) — degrade silently.
        }
      }

      connectedCallback() {
        this.handle = this.dataset.productHandle;
        this.button = this.querySelector('button');
        if (!this.handle || !this.button) return;

        this.syncState();
        this.button.addEventListener('click', this.onToggle);
        // Keep every instance of the same product in sync (other tabs too).
        window.addEventListener('storage', this.onStorage);
        document.addEventListener('wishlist:change', this.onExternalChange);
      }

      disconnectedCallback() {
        window.removeEventListener('storage', this.onStorage);
        document.removeEventListener('wishlist:change', this.onExternalChange);
      }

      onToggle = () => {
        const handles = WishlistButton.read();
        const index = handles.indexOf(this.handle);
        if (index === -1) {
          handles.push(this.handle);
        } else {
          handles.splice(index, 1);
        }
        WishlistButton.write(handles);
        document.dispatchEvent(new CustomEvent('wishlist:change'));
      };

      onStorage = (event) => {
        if (event.key === WishlistButton.storageKey) this.syncState();
      };

      onExternalChange = () => this.syncState();

      syncState() {
        // aria-pressed alone carries the state; the accessible name stays
        // constant (ARIA APG toggle-button convention).
        const active = WishlistButton.read().includes(this.handle);
        this.button.setAttribute('aria-pressed', String(active));
      }
    }
  );
}
